import React from 'react';
import { useGetUserInfoQuery } from 'services';
import { Loading } from 'components';

import { PopupWraper } from '../../../components/popup';
import UpdateForm from './updateForm';

interface UpdateUserProps {
  userId: string;
  onClose: () => void;
  forceUpdateTable: () => void;
  refetchLeadersList: () => void;
}

const UpdateUser = ({
  userId,
  onClose,
  forceUpdateTable,
  refetchLeadersList,
}: UpdateUserProps) => {
  const {
    data: userInfo,
    isFetching: isFetchingUserInfo,
    refetch: refetchUserInfo,
  } = useGetUserInfoQuery({ userId });

  if (isFetchingUserInfo && !userInfo) {
    return <Loading isLoading={true} />;
  }

  return (
    <div className='wrap-pop-up-update-user'>
      <PopupWraper title='Cập nhật thông tin người dùng' onClose={onClose}>
        <div className='container-fluid Form__Updateuser'>
          <UpdateForm
            dataForm={userInfo?.data}
            userId={userId}
            onClose={onClose}
            forceUpdateTable={forceUpdateTable}
            refetchUserInfo={refetchUserInfo}
            refetchLeadersList={refetchLeadersList}
          />
        </div>
      </PopupWraper>
    </div>
  );
};

export default UpdateUser;
